// import logo from './logo.svg';
import { Suspense, useEffect, /*useState*/ } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom'
import Home from './pages/Home';
import Login from './pages/Login';
import ListAbsen from './pages/ListAbsen';
import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import { generateTokenAction } from './redux/action/auth.action';
import LaporanKerja from './pages/LaporanKerja';
import Profile from './pages/Profile';
import EditProfile from './pages/Profile/edit';
import Payroll from './pages/Payroll';
import DetailPayroll from './pages/Payroll/detail';
import RencanaIzin from './pages/RencanaIzin';
import AddRencanaIzin from './pages/RencanaIzin/add';

import ListTugasKerja from './pages/TugasKerja/list';
import TugasKerja from './pages/TugasKerja';
import DetailTugas from './pages/TugasKerja/detail';

import DetailAbsen from './pages/Profile/detailAbsen';
import ProfileLaporanKerja from './pages/Profile/laporanKerja';
import Info from './pages/Informasi';
import DetailInfo from './pages/Informasi/detail';
import Absen from "./pages/absen";
import Notification from './pages/Notification';
// import Profile from './pages/Profile';
// import EditProfile from './pages/EditProfile';


const ProtectedLogin = ({ Component }) => {
  const generateToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)
  

  if (user === null || user === undefined  ||  Object.keys(user).length === 0) {
    return generateToken && <Component />
  }

  else if (user !== null) {
    return <Navigate to="home" />
  }
}

const ProtectedRoute = ({  Component }) => {
  const generateToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)

  
        if (user !== null) {
          // return user.isLogin === 1 ? <Component /> : <Redirect to='/change-password' />
          return <Component />
        } else {
          return generateToken && <Navigate to='/' />
        }
      
    
}

function App() {

  const dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  useEffect(() => {
    // dispatch(
    //   generateTokenAction({
    //     clientKey: process.env.REACT_APP_CLIENT_KEY,
    //     secretKey: process.env.REACT_APP_SECRET_KEY
    //   }, (error) => setState(error)))
    if (user === null || user === undefined  ||  Object.keys(user).length === 0) {
      dispatch(
        generateTokenAction({
          client: process.env.REACT_APP_CLIENT_KEY,
          secret: process.env.REACT_APP_SECRET_KEY
        })
      )
        .then(res => {
          console.log(res.data.StatusCode)
        })
        .catch(err => console.log('error get token', err))
    }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Suspense>
        <Routes>
          <Route exact path="/" element={<ProtectedLogin Component={Login} />} />
          <Route path="/home" element={<ProtectedRoute Component={Home} />} />

          <Route exact path="/profile" element={<ProtectedRoute Component={Profile} />} />
          <Route path="/profile/edit" element={<EditProfile />} />
          <Route path="/profile/detail-absen" element={<DetailAbsen />} />
          <Route path="/profile/laporan-kerja" element={<ProfileLaporanKerja />} />
          <Route path="/absen" element={<Absen />} />

          <Route exact path="/info" element={<Info />} />
          <Route path="/info/:id" element={<DetailInfo />} />
          <Route path="/rencana-izin" element={<RencanaIzin />} />
          <Route path="/buat-jadwal" element={<AddRencanaIzin />} />
          <Route path="/list-absen" element={<ListAbsen />} />
          <Route path="/laporan-kerja" element={<LaporanKerja />} />

          <Route exact path="/tugas-kerja" element={<TugasKerja />} />
          <Route exact path="/tugas-kerja/:id" element={<ListTugasKerja />} />
          <Route path="/tugas-kerja/:id/:detail" element={<DetailTugas />} />
          
          <Route path="/payroll" element={<Payroll />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/detail-payroll" element={<DetailPayroll />} />
        </Routes>
      </Suspense>
    </Router>

  );
}

export default App;


// import axios from "axios";
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { generateTokenAction } from "./redux/action/auth.action";

// const baseURL = "http://128.199.125.236/hrdku-dev/gateway/public/api/v1/staff/authenticate";

// export default function App() {
//   const dispatch = useDispatch()

//   useEffect(() => {
//         // dispatch(
//         //   generateTokenAction({
//         //     clientKey: process.env.REACT_APP_CLIENT_KEY,
//         //     secretKey: process.env.REACT_APP_SECRET_KEY
//         //   }, (error) => setState(error)))
    
//         dispatch(
//           generateTokenAction({
//             client: process.env.REACT_APP_CLIENT_KEY,
//             secret: process.env.REACT_APP_SECRET_KEY
//           })
//         )
//           .then(res => {
//             console.log(res.data.StatusCode)
//           })
//           .catch(err => console.log('error get token', err))
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//       }, [])
//   const [post, setPost] = React.useState(null);
//   const jwtToken = useSelector(state => state.auth.generateToken)



//   const header = {
//     Authorization: `Bearer ${jwtToken}`,
//     'Content-Type': 'application/json'
//   }

//   const data = {
//     username: "test@email.com",
//     password: "123123"
//   }

//   function createPost() {
//     axios
//       .post(baseURL, data, {headers: header})
//       .then((response) => {
//         setPost(response.data);
//       });
//   }

//   // if (!post) return "No post!"

//   return (
//     <div>
//       {/* <h1>{post.title}</h1>
//       <p>{post.body}</p> */}
//       <button onClick={createPost}>Create Post</button>
//     </div>
//   );
// }